"use strict";
(self["webpackChunktom_bihn"] = self["webpackChunktom_bihn"] || []).push([[4325,7931,4196],{

/***/ 7931:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9755);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utilities_toggle_scroll__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4196);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7711);




const SlideCartAPI = {
  init: function (slideCart) {
    this.rootAPI = new ___WEBPACK_IMPORTED_MODULE_1__["default"]({ name: 'slideCartAPI', key: 'slideCart', wrapper: slideCart })

    this.buildConfig(slideCart)
    this.buildUtilities()

    this.rootAPI.init()
  },

  buildConfig: function (slideCart) {
    const root = this.rootAPI
    const api = root.api

    const selectors = {
      cartInner: '[data-cart-section="inner"]',
    }
    root.selectors = selectors
    api.selectors = selectors

    const cache = {
      $slideCart: jquery__WEBPACK_IMPORTED_MODULE_0___default()(slideCart),
    }
    root.cache = cache
    api.cache = cache

    const lifecycle = {
      open: 'SlideCart.open',
      close: 'SlideCart.close',
      toggle: 'SlideCart.toggle',
      update: 'SlideCart.update',
    }
    root.lifecycle = lifecycle
    api.lifecycle = lifecycle
  },

  // Functions that are useful from outside the api
  buildUtilities: function () {
    const api = this.rootAPI.api

    // Toggle the cart open/close state
    api.toggle = function () {
      const { cache } = api.root

      const cartIsOpen = cache.$slideCart.hasClass(config.classes.active)
      if (cartIsOpen) {
        api.close()
      } else {
        api.open()
      }
    }

    api.open = function () {
      const { cache, lifecycle } = api.root
      const { overlay } = osAPI

      // Close any open popups
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).trigger('popup:close')

      cache.$slideCart.addClass(config.classes.active)
      cache.$slideCart.trigger(lifecycle.open)
      cache.$slideCart.trigger(lifecycle.toggle, { isOpen: true })

      // Show overlay
      // if (overlay) overlay.show()
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('.js-overlay').addClass('active cart-overlay')

      // Lock scrolling outside the cart
      ;(0,_utilities_toggle_scroll__WEBPACK_IMPORTED_MODULE_2__.lockScroll)()
    }

    api.close = function () {
      const { cache, lifecycle } = api.root
      const { overlay } = osAPI

      cache.$slideCart.removeClass(config.classes.active)
      cache.$slideCart.trigger(lifecycle.close)
      cache.$slideCart.trigger(lifecycle.toggle, { isOpen: false })

      // Remove overlay
      // if (overlay) overlay.hide()
      jquery__WEBPACK_IMPORTED_MODULE_0___default()('.js-overlay').removeClass('active cart-overlay')

      // Unlock scrolling outside the cart
      ;(0,_utilities_toggle_scroll__WEBPACK_IMPORTED_MODULE_2__.unlockScroll)()
    }

    api.render = function () {
      const { cart: cartAPI } = osAPI
      const { cache, lifecycle, selectors, wrapper } = api.root

      const cart = cartAPI.get()
      const sectionID = cache.$slideCart.data('section-id')

      cache.$slideCart.trigger(lifecycle.update, cart)

      jquery__WEBPACK_IMPORTED_MODULE_0___default().ajax(`/?sections=${sectionID}`).then(function (response) {
        if (!response[sectionID]) return

        // Create references to the current & new cart elements
        const $cartInner = cache.$slideCart.find(selectors.cartInner)
        const $newCartInner = jquery__WEBPACK_IMPORTED_MODULE_0___default()(response[sectionID]).find(selectors.cartInner)

        // Get the last active cart element
        const activeElementId = document.activeElement.getAttribute('id')
        const $activeElement = $newCartInner.find(`#${activeElementId}`)

        // Update the DOM
        $cartInner.replaceWith($newCartInner)

        // Set focus on the last active element OR the first focusable child
        const activeElementIsDefined = !!$activeElement.length
        
        const $firstFocusableChild = wrapper.findFocusable(':first')

        const $newFocusTarget = activeElementIsDefined ? $activeElement : $firstFocusableChild

        $newFocusTarget.trigger('focus')
      })
    }
  },
}

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SlideCartAPI);


/***/ }),

/***/ 4325:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ slideCart)
});

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__(9755);
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);
;// CONCATENATED MODULE: ./node_modules/@on-sight/dev-tools/src/utils/debounce.js

/**
 * Debounce
 * @param {*} callback 
 * @param {*} wait 
 * @returns 
 */

function debounce(callback, wait = 200) {
  let timeoutId = null

  return (...args) => {
    window.clearTimeout(timeoutId)

    timeoutId = window.setTimeout(() => {
      callback.apply(this, args)
    }, wait)
  }
}
// EXTERNAL MODULE: ./dev/js/api/slide-cart.js
var slide_cart = __webpack_require__(7931);
;// CONCATENATED MODULE: ./dev/js/components/global/slide-cart-new.js




function slideCart({ wrapper }) {
  try {
    slide_cart["default"].init(wrapper)
    console.log('✅ SlideCartAPI.init() successful')
  } catch (error) {
    console.error('❌ SlideCartAPI.init() failed:', error)
  }

  const { slideCart, cart: cartAPI } = window.osAPI || {}

  // TailwindCSS variants representing different states

  const { classes } = window.config || {}

  const selectors = {
    // Outer
    addByID: '[data-hook="addProductByID"]',
    productForm: 'form[action="/cart/add"]',
    toggleBtn: '[data-hook="toggle-cart"]',

    // Inner
    cartCount: '[data-hook="cart-count"]',
    cartItem: '[data-hook="cart-item"]',
    cartNote: '[data-hook="cart-note"]',
    closeCart: '[data-hook*="close-cart"]',
    quantityInput: '[data-hook="quantity"]',
    removeItemBtn: '[data-hook="remove-item"]',
    updateSellingPlan: '[data-hook="update-selling-plan"]',
    upgradeToSubscriptionBtn: '[data-hook="upgrade-to-sub"]',
  }

  ;(function init() {
    
    // Initial Cart get request + Render
    if (cartAPI && cartAPI.getCart && slideCart && slideCart.render) {
      cartAPI.getCart().then(slideCart.render).catch(error => {
        console.error('❌ Failed to get cart:', error)
      })
    } else {
      console.warn('⚠️ cartAPI.getCart() or slideCart.render() not available')
    }

    checkURL()
    initOuterEventListeners()
    
    initInnerEventListeners()
  })()

  // Automatically opens cart on redirect from '/cart' if '?open_cart' is present in the URL
  function checkURL() {
    if (new URL(location).searchParams.has('open_cart')) slideCart.open()
  }

  function initOuterEventListeners() {
    const { addByID, productForm, toggleBtn } = selectors

    // Lifecycles
    if (cartAPI && cartAPI.on) {
      cartAPI.on('done', handleRequestComplete)
    } else {
      console.warn('⚠️ cartAPI.on() not available')
    }
    
    if (slideCart && slideCart.on) {
      slideCart.on('update', onUpdate)
    } else {
      console.warn('⚠️ slideCart.on() not available')
    }
    
    // slideCart.on('close', handleClose)
    if (slideCart && slideCart.close) {

      jquery_default()('.js-overlay').on('click', slideCart.close)

    } else {
      console.warn('⚠️ slideCart.close() not available')
    }

    // Elements
    jquery_default()(document).on('click', addByID, addProductByID)
    jquery_default()(document).on('submit', productForm, onProductSubmit)
    
    if (slideCart && slideCart.toggle) {
      jquery_default()(document).off('click', toggleBtn).on('click', toggleBtn, slideCart.toggle)
    } else {
      jquery_default()(document).off('click', toggleBtn).on('click', toggleBtn, function(e) {
        e.preventDefault()
        // Fallback: just open the cart
        if (slideCart && slideCart.open) {
          slideCart.open()
        } else {
          console.error('❌ No cart open method available')
        }
      })
    }
  }

  function initInnerEventListeners() {
    const { closeCart, removeItemBtn, upgradeToSubscriptionBtn, updateSellingPlan, cartNote, quantityInput } = selectors

    jquery_default()(wrapper).on('click', closeCart, slideCart.close)
    jquery_default()(wrapper).on('click', removeItemBtn, removeItem)
    jquery_default()(wrapper).on('click', upgradeToSubscriptionBtn, updateSubscription)
    jquery_default()(wrapper).on('change', updateSellingPlan, updateSubscription)
    jquery_default()(wrapper).on('change', cartNote, updateCartNote)
    jquery_default()(wrapper).on('quantity-box:change', quantityInput, debounce(changeItemQuantity))
  }

  // * Lifecycle

  function handleRequestComplete(event, { type }) {
    if (type == 'get') return

    // Gets and caches the latest cart, then renders the cart
    cartAPI.getCart().then(slideCart.render).then(() => {
      // Refresh cart upsell recommendations after cart update
      refreshCartUpsellRecommendations()
    })
  }

  function onUpdate(event, cart) {
    updateCartCount(cart.item_count)
  }

  // * Event handlers

  // Add a product to the cart using `data-variant-id`
  function addProductByID(event) {
    const id = jquery_default()(this).data('variant-id')

    cartAPI.addItem(id)
  }

  // Handle the submission of a product form
  function onProductSubmit(event) {
    event.preventDefault()

    const $form = jquery_default()(this)
    const isCartUpsell = $form.data('cart-upsell')
    
    // Add loading indicator to product form
    $form.addClass(classes.loading)

    if (isCartUpsell) {
      // For cart upsells, use simple form serialization
      const data = $form.serialize()
      const requestOptions = { data, url: cartAPI.urls.add, error: () => cleanupError($form) }
      cartAPI.processRequest(requestOptions).then(() => cleanupPostRequest($form))
    } else {
      // For product page forms, handle add-on products like the old system
      handleProductFormWithAddons($form)
    }
  }

  // Handle product form submission with add-on products (bundled items)
  function handleProductFormWithAddons($form) {
    const quantity = $form.find('[name="quantity"]').val() || 1
    const idInputs = $form.find('[name="id"]')
    let id = idInputs.val()
    if (idInputs.length > 1) {
      id = idInputs.filter(':checked').val()
    }
    const variantName = $form.find('[name="id"] option:selected').text()
    const productName = $form.attr('data-productname') || $form.find('[name="id"] option:selected').text()
    
    // Collect properties
    const properties = {}
    const propertyInputs = $form.find('[name*="properties"]')
    propertyInputs.each(function (index, input) {
      const inputVal = jquery_default()(input).val()
      const isDisabled = jquery_default()(input).is(':disabled')
      const inputName = jquery_default()(input).prop('name').replace('properties[', '').replace(']', '')
      
      if (!isDisabled && !!inputVal) {
        properties[inputName] = inputVal
      }
    })

    // Start with the main product
    const items = [
      {
        quantity: quantity,
        id: id,
        properties: properties
      }
    ]

    // Add any checked add-on products
    jquery_default()('.js-add-on').each((index, el) => {
      if (jquery_default()(el).is('[type=checkbox]') && jquery_default()(el).prop('checked') == false) {
        return
      }

      const value = jquery_default()(el).val()
      if (value) {
        const item = {
          id: value,
          quantity: quantity,
          properties: {
            'Bundled With': productName + ' - ' + variantName,
            _bundleId: id,
          },
        }
        items.push(item)
      }
    })

    const data = { items: items }
    const requestOptions = { data, url: cartAPI.urls.add, error: () => cleanupError($form) }
    cartAPI.processRequest(requestOptions).then(() => cleanupPostRequest($form))
  }

  // Remove an item from the cart
  function removeItem() {
    const $item = jquery_default()(this).closest(selectors.cartItem)
    const key = $item.data('key')

    // Add loading indicator to cart item
    $item.addClass(classes.loading)

    // Get current cart to find bundled items
    cartAPI.getCart().then((cart) => {
      const data = { updates: {} }
      
      // Add the main item to be removed
      data.updates[key] = 0
      
      // Find bundled items that should be removed with this item
      const parentItem = cart.items.find((item) => item.key == key)
      if (parentItem) {
        const bundledItems = cart.items.filter((item) => {
          const bundleId = item.properties?._bundleId
          return bundleId && bundleId == parentItem.variant_id
        })
        
        // Add bundled items to removal list
        bundledItems.forEach((item) => {
          data.updates[item.key] = 0
        })
      }
      
      // Make the cart update request
      const requestOptions = { data, url: cartAPI.urls.update, error: () => cleanupError($item) }
      return cartAPI.processRequest(requestOptions)
    }).then(() => {
      // Remove loading indicator
      $item.removeClass(classes.loading)
    }).catch(() => {
      // Remove loading indicator on error
      $item.removeClass(classes.loading)
    })
  }

  // Handle the change in quantity for an item
  function changeItemQuantity(event) {
    const $quantityInput = jquery_default()(event.target)
    const $item = $quantityInput.closest(selectors.cartItem)

    const key = $item.data('key')
    const quantity = parseInt($quantityInput.val())

    // Add loading indicator to cart item
    $item.addClass(classes.loading)

    // If quantity is 0, handle bundled items removal
    if (quantity === 0) {
      // Get current cart to find bundled items
      cartAPI.getCart().then((cart) => {
        const data = { updates: {} }
        
        // Add the main item to be removed
        data.updates[key] = 0
        
        // Find bundled items that should be removed with this item
        const parentItem = cart.items.find((item) => item.key == key)
        if (parentItem) {
          const bundledItems = cart.items.filter((item) => {
            const bundleId = item.properties?._bundleId
            return bundleId && bundleId == parentItem.variant_id
          })
          
          // Add bundled items to removal list
          bundledItems.forEach((item) => {
            data.updates[item.key] = 0
          })
        }
        
        // Make the cart update request
        const requestOptions = { data, url: cartAPI.urls.update, error: () => cleanupError($item) }
        return cartAPI.processRequest(requestOptions)
      }).then(() => {
        // Remove loading indicator
        $item.removeClass(classes.loading)
      }).catch(() => {
        // Remove loading indicator on error
        $item.removeClass(classes.loading)
      })
    } else {
      // Normal quantity update
      cartAPI.updateQuantityByKey(key, quantity).then(() => cleanupPostRequest($item))
    }
  }

  // Update the item subscription / selling_plan
  function updateSubscription(event) {
    // convert this to cartAPI method -> selling_plan, line_item
    event.preventDefault()

    const $trigger = jquery_default()(this)
    const $item = $trigger.closest(selectors.cartItem)
    let { key, quantity, sellingPlan } = $trigger.data()

    if ($trigger.val()) {
      sellingPlan = $trigger.val()
    }

    const data = {
      quantity: quantity,
      id: key,
      selling_plan: sellingPlan === 'onetime' ? '' : sellingPlan,
    }

    const requestOptions = { data, url: cartAPI.urls.change, error: () => cleanupError($item) }
    cartAPI.processRequest(requestOptions).then(() => cleanupPostRequest($item))
  }

  function updateCartNote(event) {
    const note = jquery_default()(this).val()

    cartAPI.setNote(note)
  }

  function updateCartCount(count) {
    jquery_default()(selectors.cartCount).text(count)
    
    //toggle cart button visibility based on cart count
    if (count > 0) {
      // Show blue cart button, hide black cart button
      jquery_default()('[data-cart-icon-blue]').removeClass('tw-hidden')
      jquery_default()('[data-cart-icon-black]').addClass('tw-hidden')
      jquery_default()(selectors.cartCount).removeClass('tw-hidden')
    } else {
      // Show black cart button, hide blue cart button
      jquery_default()('[data-cart-icon-black]').removeClass('tw-hidden')
      jquery_default()('[data-cart-icon-blue]').addClass('tw-hidden')
      jquery_default()(selectors.cartCount).addClass('tw-hidden')

    }
  }

  function cleanupError($trigger) {
    $trigger.removeClass(classes.loading).addClass(classes.error)
  }

  function cleanupPostRequest($trigger) {
    // Remove loading indicator from trigger
    $trigger.removeClass(classes.loading)

    slideCart.open()
  }

  // * Cart Upsell Recommendations

  function refreshCartUpsellRecommendations() {
    // Trigger refresh on all cart upsell recommendation components
    const $upsellContainers = jquery_default()(wrapper).find('[data-component="cart/cart-upsell-recommendations"]')
    
    if ($upsellContainers.length > 0) {
      console.log('🔄 Refreshing cart upsell recommendations')
      // The component will handle its own refresh logic when the cart updates
      $upsellContainers.trigger('cart:refresh')
    }
  }
}

/***/ }),

/***/ 4196:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   lockScroll: () => (/* binding */ lockScroll),
/* harmony export */   unlockScroll: () => (/* binding */ unlockScroll)
/* harmony export */ });
function lockScroll() {
  const scrollPosition = window.scrollY
  window.scrollTop = scrollPosition

  document.body.style.overflow = 'hidden'
  document.body.style.position = 'fixed'
  document.body.style.top = `-${scrollPosition}px`
  document.body.style.width = '100%'
}

function unlockScroll() {
  const scrollPosition = window.scrollTop

  document.body.style.removeProperty('overflow')
  document.body.style.removeProperty('position')
  document.body.style.removeProperty('top')
  document.body.style.removeProperty('width')

  if (!scrollPosition) return
  window.scrollTo({ top: scrollPosition, behavior: 'instant' })
  window.scrollTop = 0
}


/***/ })

}]);